<ng-container *transloco="let t">
  <span class="app-footer-version" [attr.aria-label]="t('common.appVersionLabel')">v{{ version }}</span>
</ng-container>
